import { Component, OnInit } from '@angular/core';
import { MiInvoiceFooterComponent } from '../mi-components/mi-invoice-footer/mi-invoice-footer.component';
import { MiInvoiceHeaderComponent } from '../mi-components/mi-invoice-header/mi-invoice-header.component';
import {
  IManualInvoicePrimaryPrelim,
  IMiPrelimHeader,
  IMiPrelimBillingLines,
  IMiPrelimPaymentsAdjustments,
  IMiPrelimFooter,
} from 'src/app/shared/interfaces';
import { JsonPipe } from '@angular/common';
import { MiInvoiceBillingLinesComponent } from '../mi-components/mi-invoice-billing-lines/mi-invoice-billing-lines.component';
import { MiTotalTestComponent } from '../mi-components/mi-total-test/mi-total-test.component';

@Component({
  selector: 'app-manual-invoice-primary',
  standalone: true,
  imports: [MiInvoiceBillingLinesComponent, MiInvoiceFooterComponent, MiInvoiceHeaderComponent, MiTotalTestComponent],
  templateUrl: './manual-invoice-primary.component.html',
  styleUrl: './manual-invoice-primary.component.scss',
})
export class ManualInvoicePrimaryComponent implements OnInit {
  miPrelimData: IManualInvoicePrimaryPrelim = {} as IManualInvoicePrimaryPrelim;

  constructor() {}

  ngOnInit(): void {
    this.miPrelimData.miHeader = mockInvoiceHeader;
    this.miPrelimData.miBillingLines = mockBillingLines;
    this.miPrelimData.miPaymentsAdjustments = mockPaymentsAdjustments;
    this.miPrelimData.miFooter = mockFooter;
  }
}

export const mockInvoiceHeader: IMiPrelimHeader = {
  aceCompanyName: 'Ace Parking',
  lotName: '222 Kearney Street',
  lotAddress1: '2875 A Street',
  lotAddress2: 'Suite 840',
  lotCity: 'San Diego',
  lotState: 'CA',
  lotZip: '92101',
  lotPhoneNumber: '619-999-9999',
  lotEmailAddress: 'lgonzalez@aceparking.com',
  customerName: 'Moss, Ken',
  customerAddress1: '123 Main Street',
  customerAddress2: 'Apt. 1',
  customerCity: 'San Diego',
  customerState: 'CA',
  customerEmailAddress: 'kmoss@aceparking.com',
  customerPhoneNumber: '619-555-1212',
  customerAttentionContactName: 'Ken Moss',
  customerZip: '92101',
  invoiceNumber: 'MI##############',
  invoiceDate: new Date('5/27/24'),
  dueDate: new Date('6/1/25'),
  totalBalance: 501.23,
};

export const mockBillingLines: IMiPrelimBillingLines[] = [
  {
    billingLine: 1,
    quantity: 2,
    rate: 100,
    revCode: 'LATF',
    revType: 'Late Fee',
    description: 'Description Line One',
    sequenceStart: '100',
    sequenceEnd: '102',
    amount: 200.0,
    tax: 52.0,
    total: 252,
  },
  {
    billingLine: 2,
    quantity: 1,
    rate: 100,
    revCode: 'MONT',
    revType: 'Monthly Parking',
    description: 'Description Parking',
    sequenceStart: '103',
    sequenceEnd: '104',
    amount: 100.0,
    tax: 26.0,
    total: 126.0,
  },
];

export const mockPaymentsAdjustments: IMiPrelimPaymentsAdjustments[] = [
  {
    adjustmentLineId: 1,
    adjustmentType: 'Added',
    adjustmentDate: new Date('05-27-2025'),
    adjustmentDescription: 'Monthly Parking',
    amount: 100.0,
    tax: 26.0,
    total: 126.0,
  },
  {
    adjustmentLineId: 1,
    adjustmentType: 'Payment',
    adjustmentDate: new Date('05-28-2025'),
    adjustmentDescription: 'ACH 29094643',
    amount: -40,
    tax: 0,
    total: -40,
  },
];

export const mockFooter: IMiPrelimFooter = {
  totalAmount: 100.0,
  invoiceCommentsFromUser: 'User Comments during Invoice Creation',
  globalFooterVerbiage: 'This is the lot specific Footer Message',
  companyTagLineVerbiage: 'Every Thank You Earned',
};
